import TopicHeader from '../../../Utilities/TopicHeader';
import DurationSearchHead from '../../../Utilities/DurationSearchHead';
import { useEffect, useState, useCallback } from 'react';
import { format, subDays } from 'date-fns';
import { useSelector } from 'react-redux';
import { post } from '../../Auths/AuthToken';
import setUiMessage from '../../../Utilities/Tostify';
import Pagination from '../../../Utilities/Pagination';
import ReferralList from './ReferralList';
import { debounce } from 'lodash';
import AddReferralPopup from './AddReferralPopup';
import ConfirmDialog from '../../../Utilities/ConfirmDialog';

function Referral() {
  const { user } = useSelector((store) => store.auth);
  const [openNewReferralForm, setOpenNewReferralForm] = useState({
    status: false,
    refId: null,
    rptSentId: null,
    patientId: null,
    reportId: null,
  });
  const [limit, setSetLimit] = useState(200);
  const [offset, setSetOfset] = useState(0);
  const [allData, setAllData] = useState([]);
  const [reload, setReload] = useState(false);

  const [referralData, setReferralData] = useState({
    startDate: subDays(new Date(), 7),
    endDate: new Date(),
    filterValue: '7D',
    selectedState: '',
    isDateRange: false,
    provider: { value: 'ALL', label: 'All Providers' },
    searchTermName: '',
    searchTermChart: '',
    docSent: 'ALL',
    refAppTaken: 'ALL',
    searchTermStatus: '',
  });

  const [deleteReferral, setDeleteReferral] = useState({
    open: false,
    refId: '',
  });

  const handleFilterChange = useCallback((data) => {
    setReferralData(data);
    setSetOfset(0);
  }, []);

  const handlePageChange = useCallback((data) => {
    setSetLimit(data[1]);
    setSetOfset(data[0]);
  }, []);

  useEffect(() => {
    // Prevent calling API when date range is incomplete
    if (
      referralData.isDateRange &&
      (!referralData.startDate || !referralData.endDate)
    )
      return;

    const fetchResults = async () => {
      try {
        const response = await post(
          'api/patient/referral/loadReferralGridView',
          {
            ...referralData,
            loginUserId: user?.id,
            limit,
            offset,
            startDate: referralData.startDate
              ? format(referralData.startDate, 'yyyy-MM-dd')
              : '',
            endDate: referralData.endDate
              ? format(referralData.endDate, 'yyyy-MM-dd')
              : '',
            provider: referralData.provider?.value || '',
          },
        );

        if (response.status === 200) {
          setAllData(response.data);
        }
      } catch (err) {
        setUiMessage('err', err?.message);
      }
    };

    // Memoize the debounced version so it doesn�t reinitialize on every render
    const debouncedFetch = debounce(fetchResults, 500);

    debouncedFetch(referralData.searchTermChart);

    // Cleanup on unmount
    return () => {
      debouncedFetch.cancel();
    };
  }, [referralData, limit, offset, user?.id, reload]);

  const reopenReferralPopup = (refId, rptSentId, patientId, reportId) => {
    setOpenNewReferralForm({
      status: true,
      refId: refId,
      rptSentId: rptSentId,
      patientId: patientId,
      reportId: reportId,
    });
  };

  const handleDeleteReferral = (refId) => {
    setDeleteReferral({
      open: true,
      refId: refId,
    });
  };

  const confirmDeleteReferral = async () => {
    try {
      if (deleteReferral?.refId) {
        const response = await post('api/CommonTask/deleteReferralRow', {
          refId: deleteReferral.refId,
        });
        if (response.status === 200) {
          setUiMessage('suc', 'Referral deleted successfully.');
          setReload(!reload);
          setDeleteReferral({
            open: false,
            refId: '',
          });
        }
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  const handleChangeStatus = async (refId, status) => {
    try {
      const response = await post('api/patient/referral/updateReferralStatus', {
        refId,
        status,
      });
      if (response.status === 200) {
        setUiMessage('suc', 'Status updated successfully.');
        setReload(!reload);
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  return (
    <div id="referralMaingrid" className="preauth-Maingrid-Pat">
      <TopicHeader title={'Referral:'} />
      <DurationSearchHead
        duration={referralData.filterValue}
        startDate={referralData.startDate}
        endDate={referralData.endDate}
        isDateRange={referralData.isDateRange}
        isProviderDd
        options={allData?.allProviders || []}
        selectedProvider={referralData?.provider}
        setData={handleFilterChange}
        openPopup={() =>
          setOpenNewReferralForm({
            status: true,
            refId: null,
            rptSentId: null,
            patientId: null,
            reportId: null,
          })
        }
      />
      <div className="intake-paging">
        <Pagination
          totalRecord={Number(allData && allData?.rowCount) || 0}
          onPageChange={handlePageChange}
          offset={offset}
          rowPerPage={limit}
        />
      </div>

      {/* preauth-Maingrid-Patbdy grid-sec clear-top10 pt-referral-grid */}
      <div className="w-100 fs-13 overflow-x-auto ">
        {/* <div className="referral-Maingrid-Pat-hdr grid-sec"> */}
           {/* preauth-Maingrid-Pat-sbhdr flex-sec  */}
          <div className="grid header gridRow items-start">
            <div className="border-r border-r-lightgray p-2 bg-gray-100 text-dark fw-600">Status</div>
            <div className="border-r border-r-lightgray p-2 bg-gray-100 text-dark fw-600">Chart#</div>
            <div className="border-r border-r-lightgray p-2 bg-gray-100 text-dark fw-600">Patient Name</div>
			{/* <div className="border-r border-r-lightgray p-2 bg-gray-100 text-dark fw-600">Contact Info</div>
<div className="border-r border-r-lightgray p-2 bg-gray-100 text-dark fw-600">Patient Address</div> */}
            <div className="border-r border-r-lightgray p-2 bg-gray-100 text-dark fw-600">Referring Provider</div>
            <div className="border-r border-r-lightgray p-2 bg-gray-100 text-dark fw-600">Referred To</div>
            <div className="border-r border-r-lightgray p-2 bg-gray-100 text-dark fw-600">Date & Urgency</div>
            <div className="border-r border-r-lightgray p-2 bg-gray-100 text-dark fw-600">Reason for Referral</div>
            <div className="border-r border-r-lightgray p-2 bg-gray-100 text-dark fw-600">Planed Date</div>
			{/*    <div className="border-r border-r-lightgray p-2 bg-gray-100 text-dark fw-600">Note Status</div>
            <div className="border-r border-r-lightgray p-2 bg-gray-100 text-dark fw-600">Doc Sent</div> */}
            <div className="border-r border-r-lightgray p-2 bg-gray-100 text-dark fw-600">Appointment Status</div>
            <div className="border-r border-r-lightgray p-2 bg-gray-100 text-dark fw-600">Action</div>
          </div>
          {/* preauth-Maingrid-Pat-sbhdr refrl-sb-child flex-sec */}
          <div className="grid search gridRow tems-stretch">
            <div className="p-1-5 border-r border-r-lightgray">
              <select
                id="refralstatus"
                name="refralstatus"
                value={referralData.searchTermStatus || ''}
                onChange={(e) =>
                  handleFilterChange((prev) => ({
                    ...prev,
                    searchTermStatus: e.target.value,
                  }))
                }
              >
                <option value="">All Status</option>
                <option value="1">Pending</option>
                <option value="2">Scheduled</option>
                <option value="3">Completed</option>
                <option value="4">Canceled</option>
                <option value="5">Removed</option>
              </select>
            </div>
            <div
              className="p-1-5 border-r border-r-lightgray"
              qstyle={{ width: 'calc(8% - 5px) !important' }}
            >
              <input
                type="text"
                className="inpt-width-nw width100"
                placeholder="Search here..."
                id="chartnumber"
                name="chartnumber"
                value={referralData.searchTermChart || ''}
                onChange={(e) =>
                  handleFilterChange((prev) => ({
                    ...prev,
                    searchTermChart: e.target.value,
                  }))
                }
              />
            </div>
            <div className="p-1-5 border-r border-r-lightgray">
              <input
                type="text"
                className="inpt-width-nw width100"
                placeholder="Search here..."
                id="patientname"
                name="patientname"
                value={referralData.searchTermName || ''}
                onChange={(e) =>
                  handleFilterChange((prev) => ({
                    ...prev,
                    searchTermName: e.target.value,
                  }))
                }
              />
            </div>
			{/*  <div className="p-1-5 border-r border-r-lightgray"></div>
            <div className="p-1-5 border-r border-r-lightgray"></div> */}
            <div className="p-1-5 border-r border-r-lightgray"></div>
            <div className="p-1-5 border-r border-r-lightgray"></div>
            <div className="p-1-5 border-r border-r-lightgray"></div>
            <div className="p-1-5 border-r border-r-lightgray"></div>
            <div className="p-1-5 border-r border-r-lightgray"></div>
			{ /*   <div className="p-1-5 border-r border-r-lightgray"></div>
            <div className="p-1-5 border-r border-r-lightgray">
              <select
                className="inpt-width-nw width100"
                value={referralData.docSent}
                onChange={(e) =>
                  handleFilterChange((prev) => ({
                    ...prev,
                    docSent: e.target.value,
                  }))
                }
              >
                <option value="ALL">All</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
</div> */}
            <div className="p-1-5 border-r border-r-lightgray">
              <select
                className="inpt-width-nw width100"
                value={referralData.refAppTaken}
                onChange={(e) =>
                  handleFilterChange((prev) => ({
                    ...prev,
                    refAppTaken: e.target.value,
                  }))
                }
              >
                <option value="ALL">All</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
            <div className="p-1-5 border-r border-r-lightgray"></div>
          </div>

        {/* </div> */}
        {/* intake-Maingrid-Pat-sb-bdy qgrid-sec */}
        {allData?.referralAllData &&
			allData?.referralAllData?.map((item, i) => (
          <div
            key={i}
            className={`grid gridRow ${i % 2 === 0 ? "even" : "odd"}`}
			onClick={() =>
                  reopenReferralPopup(
                    item.id,
                    item.rptSentId,
                    item.patient_id,
                    item.report_id,
                  )
                }
			
          >
			
            <ReferralList
              item={item}
              handlePopupOpen={reopenReferralPopup}
              handleDeleteReferral={handleDeleteReferral}
              handleReload={() => setReload(!reload)}
            />
          </div>
        ))}
      </div>
      {openNewReferralForm.status && (
        <AddReferralPopup
          isOpen={openNewReferralForm.status}
          onClose={() =>
            setOpenNewReferralForm({
              status: false,
              refId: null,
              rptSentId: null,
              patientId: null,
              reportId: null,
            })
          }
          handleReload={() => setReload(!reload)}
          refId={openNewReferralForm.refId}
          rptSentId={openNewReferralForm.rptSentId}
          patientId={openNewReferralForm.patientId}
          reportId={openNewReferralForm.reportId}
        />
      )}
      {deleteReferral.open && (
        <ConfirmDialog
          title={`Confirm!`}
          bodytext={`Do you really want to delete this referral data?`}
          closeDialog={() =>
            setDeleteReferral({
              open: false,
              refId: '',
            })
          }
          successDialog={confirmDeleteReferral}
          // sucPrams={sucPrams}
        />
      )}
    </div>
  );
}

export default Referral;
